import { UserRole } from 'types/User';

const InsightsLiteConfig = {
  INCLUDED_ROLES_IN_EXPERIMENT: ['admin', 'manager'] as UserRole[],
  MAX_POSTS_PER_METRIC: 5,
};

export default InsightsLiteConfig;
